import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import './InputField.scss';
import { onChangeEvent } from '../reactive-events/onChange';

const OrgName = (props) => {
  const { name, label, errortext } = props;
  const dispatch = useDispatch();
  const ref = useRef({});
  const formObj = useSelector(({ form }) => form[form.currentForm], shallowEqual);

  const [value, setValue] = useState('');
  const [customError, setCustomError] = useState('');

  const onOrgNameChange = (e) => {
    const val = e.target.value;
    setValue(val);
    
    // Reset custom error first
    setCustomError('');
    
    // Check for special characters that are not allowed
    if(val && !/^(?!.*[ÑñÍíÁáÉéÓóÚúÜüßØøÇç]).*$/.test(val)) {
      const errorMsg = 'Organization name cannot contain special characters like Ñ, Í, Á, É, Ó, Ú, Ü, ß, Ø, Ç and their lowercase variants.';
      setCustomError(errorMsg);
      ref.current.setCustomValidity(errorMsg);
    } else if(ref.current.validity.tooShort && val.length > 0){
      const errorMsg = errortext || 'Organization name must contain at least 3 characters.';
      setCustomError(errorMsg);
      ref.current.setCustomValidity(errorMsg);
    } else {
      ref.current.setCustomValidity('');
    }
    
    dispatch(onChangeEvent(name, val));
  }

  useEffect(() => {
    let formValue = formObj && formObj.hasOwnProperty(name) ? formObj[name] : '';
    if (formValue !== value) {
      setValue(formValue);
      
      // Re-validate the form value to maintain validation state
      setCustomError('');
      if (ref.current) {
        if (formValue && !/^(?!.*[ÑñÍíÁáÉéÓóÚúÜüßØøÇç]).*$/.test(formValue)) {
          const errorMsg = 'Organization name cannot contain special characters like Ñ, Í, Á, É, Ó, Ú, Ü, ß, Ø, Ç and their lowercase variants.';
          setCustomError(errorMsg);
          ref.current.setCustomValidity(errorMsg);
        } else {
          ref.current.setCustomValidity('');
        }
      }
    }
  }, [name, formObj, value]);

  return (
    <div style={{ gridArea: name }}>
      <p className={`sisp-label ${ !props.hasOwnProperty('required') ? 'sisp-input--required' : ''}`}>{label}</p>
      <input
        ref={ref}
        value={value}
        onChange={onOrgNameChange}
        required
        {...props}
      ></input>
      <p className='sisp-input-helper'>{customError || ref.current.validationMessage || errortext || ''}</p>
    </div>
  );
};

export default React.memo(OrgName);
